import APIServiceLookUp from './serviceAPI';
import { MAIN_API_URL } from './models/AppConstent';

export default class ServiceOrder {
    lookupService = new APIServiceLookUp();

    async getAllOrders(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}order/getAllOrders`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllOrdersWithUnit(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}order/getAllOrdersWithUnit`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async createQSRInvoice(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}terminal/createDirectInvoice`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async createPOSOrder(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}terminal/createPOSOrder`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async createPOSInvoice(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}terminal/createPOSInvoice`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateOrder(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}order/updateOrder`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async shiftUnit(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}order/shiftUnit`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateOrderWithRef(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}order/updateOrderWithRef`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getInvoiceWithRef(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}invoice/getInvoiceWithRef`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async settlePOSInvoice(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}invoice/settlePOSInvoice`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}